(function() {

	let docElm = document.documentElement;

	docElm.className = docElm.className.replace('no-js','js');

	if (!window.console || typeof window.console === 'undefined') {
		window.console = {
			log: function() {},
			error: function() {}
		};
	}

	if (!('requestAnimationFrame' in window)) {
		docElm.className += ' no-raf';
	}

}());
